import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../../reducers";
import StringHelper from "../../../services/Common/StringHelper";
import FooterSocialMedia from "./components/FooterSocialMedia";
import {selectLocale} from "../../../services/Session/reducer";
import {ConfigApi} from "../../../services/Api/types";
import AppConfig from "../../../services/AppConfig";
import FooterLanguages from "./components/FooterLanguages";
import FooterLinks from "./components/FooterLinks";
import FooterOpeningHours from "./components/FooterOpeningHours";
import FooterStoreDetails from "./components/FooterStoreDetails";
import FooterBottom from "./components/FooterBottom";
import FooterMap from "./components/FooterMap";
import StoreUtils from "../../../services/Store/StoreUtils";


interface OwnProps {
    config: ConfigApi;
    languages: string[];
    withoutMap?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const Footer = (props: Props) => {
    const {t} = useTranslation();

    if (!props.config) return null;

    const addressFullString = props.config ? StringHelper.getAddressName(props.config.address) : undefined;
    const footerLinks = props.config.layout.links ? [...props.config.layout.links].filter((link: any) => link.type === "FOOTER").sort((a: any, b: any) => a.position - b.position || a.title.localeCompare(b.title)) : [];

    const renderListItem = (icon: any, title: string, value: any, shareIcon: any, link?: any, action?: any) => {

        const handleAction = () => {
            if (action) {
                return action()
            }
        }

        return (
            <div className={`footer-list-item ${action ? 'footer-list-item-action' : ''}`} onClick={handleAction}>
                <div className={"footer-list-icon"}>
                    {icon}
                </div>
                <div className={"footer-list-content"}>
                    {value}
                </div>
                <div className={"footer-list-action"}>
                    {action ? (
                        <button className={"btn btn-sm btn-transparent btn-icon"}
                                aria-label={t("modules.footer.action.open.title")}>
                            {shareIcon}
                        </button>
                    ) : (
                        <a className={"btn btn-sm btn-transparent btn-icon"} href={link} target={"_blank"}
                           aria-label={t("modules.footer.action.open.title")}>
                            {shareIcon}
                        </a>
                    )}
                </div>
            </div>
        )
    }
    
    return (
        <footer className="footer">
            {(!AppConfig.isNativeMobile()) && (
                <div className={"container-fluid"}>
                    <div className={"footer-store"}>
                        <div className={"row row-cols-1"}>
                            <div className={"col"}>
                                <ul className={"footer-list"}>
                                    {
                                        !StoreUtils.isMultistore(props.config) && (
                                            <>
                                                <FooterStoreDetails address={addressFullString}
                                                                    renderListItem={renderListItem} config={props.config}/>
                                                <FooterOpeningHours config={props.config} locale={props.locale}/>
                                            </>
                                        )
                                    }
                                    <FooterLanguages languages={props.languages} locale={props.locale}
                                                     renderListItem={renderListItem}/>
                                </ul>
                                <FooterSocialMedia/>
                            </div>
                            <FooterMap config={props.config} withoutMap={props.withoutMap}/>
                        </div>
                        <FooterSocialMedia config={props.config}/>
                        {footerLinks.length > 0 && (
                            <FooterLinks footerLinks={footerLinks}/>
                        )}
                    </div>
                </div>
            )}
            <FooterBottom/>
        </footer>
    )
}


const mapStateToProps = (state: RootState) => ({
    locale: selectLocale(state.session)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(Footer));
